import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const TEMPLATE_CENTER_CONTEXT_SYMBOL = Symbol();
const useTemplateCenter = ()=>useImmutableContext(TEMPLATE_CENTER_CONTEXT_SYMBOL);
const useTemplateCenterProvider = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return useImmutableContextProvider(TEMPLATE_CENTER_CONTEXT_SYMBOL, ...args);
};
export { useTemplateCenter, useTemplateCenterProvider };
